let bday = new Date(1994, 7, 30); // Gotta have month - 1 since January is 0
let now = new Date();
let diff = now - bday;
let ageDate = new Date(diff);
let age = Math.abs(ageDate.getUTCFullYear() - 1970);

export default [
  {
    id: 'me',
    label: 'Bryce',
    category: 'My Skills',
    level: 'perfect',
    experience: `${age} years`,
    projects: [''],
    color: '#7700ee',
  },
  {
    id: 'fe',
    label: 'Front-End',
    category: 'Core',
    level: 'expert',
    experience: '10+ years',
    projects: [''],
    color: '#00eeff',
  },
  {
    id: 'be',
    label: 'Back-End',
    category: 'Core',
    level: 'expert',
    experience: '9+ years',
    projects: [''],
    color: '#ff00ee',
  },
  {
    id: 'c++',
    label: 'C++',
    category: 'Backend',
    level: 'beginner',
    experience: '1 year',
    projects: ['University classes'],
    color: '#00eeff',
  },
  {
    id: 'fw',
    label: 'Frameworks',
    category: 'Front-End',
    level: 'expert',
    experience: '8+ years',
    projects: [''],
    color: '#f71e1eff',
  },
  {
    id: 'python',
    label: 'Python',
    category: 'Back-End',
    level: 'beginner',
    experience: '1 year',
    projects: ['RevelTV - Back End'],
    color: '#00eeff',
  },
  {
    id: 'db',
    label: 'Database',
    category: 'Core/Back-End',
    level: 'expert',
    experience: '10+ years',
    projects: [''],
    color: '#f71e1eff',
  },
  {
    id: 'mysql',
    label: 'MySQL',
    category: 'Database',
    level: 'expert',
    experience: '8+ years',
    projects: ['Barco - Custom Database I designed & created for vehicle management, rentals, sales, accounting & reporting',
      'RevelTV - I redesigned old MSSQL database and migrated to MySQL data'
    ],
    color: '#68a063',
  },
  {
    id: 'mssql',
    label: 'MSSQL',
    category: 'Database',
    level: 'expert',
    experience: '1 year',
    projects: ['RevelTV - MSSQL to MySQL data migration'],
    color: '#68a063',
  },
  {
    id: 'mongo',
    label: 'MongoDB',
    category: 'Database',
    level: 'expert',
    experience: '3 months',
    projects: ['University Class Project'],
    color: '#68a063',
  },
  {
    id: 'vue',
    label: 'Vue.js',
    category: 'Framework',
    level: 'expert',
    experience: '7+ years',
    projects: ['This Portfolio Site', 'Barco - Dashboard - Main employee site', 'Barco Order Forms - Online forms for clients to request more trucks, trades, or to off rent vehicles'],
    color: '#42b883',
  },
  {
    id: 'ember',
    label: 'Ember.js',
    category: 'Framework',
    level: 'advanced',
    experience: '2 years',
    projects: ['RevelTV - Channel Valet 3'],
    color: '#42b883',
  },
  {
    id: 'angular',
    label: 'Angular.js',
    category: 'Framework',
    level: 'beginner',
    experience: '3 months',
    projects: ['University class project'],
    color: '#42b883',
  },
  {
    id: 'react',
    label: 'React.js',
    category: 'Framework',
    level: 'beginner',
    experience: '1 month',
    projects: ['Personal project'],
    color: '#42b883',
  },
  {
    id: 'bs',
    label: 'Bootstrap',
    category: 'Front-End',
    level: 'expert',
    experience: '7+ years',
    projects: [''],
    color: '#00eeff',
  },
  {
    id: 'scss',
    label: 'SCSS',
    category: 'Front-End',
    level: 'expert',
    experience: '7+ years',
    projects: [''],
    color: '#00eeff',
  },
  {
    id: 'node',
    label: 'Node.js',
    category: 'Back-End',
    level: 'expert',
    experience: '7+ years',
    projects: ['Barco - Main back-end language'],
    color: '#f71e1eff',
  },
  {
    id: 'express',
    label: 'Express',
    category: 'Node.js',
    level: 'expert',
    experience: '7+ years',
    projects: [''],
    color: '#ffe51fff',
  },
  {
    id: 'sockets',
    label: 'Socket.IO',
    category: 'Node.js',
    level: 'expert',
    experience: '7+ years',
    projects: ['Barco Dashboard - Keeps everyone\'s page updated in real time'],
    color: '#ffe51fff',
  },
  {
    id: 'php',
    label: 'PHP',
    category: 'Back-End',
    level: 'expert',
    experience: '7+ years',
    projects: ['Used in lots of cron-jobs', 'University - Typing Test Project'],
    color: '#ff00ee',
  },
  {
    id: 'java',
    label: 'Java',
    category: 'Back-End',
    level: 'average',
    experience: '2 years',
    projects: ['University - multiple classes, Majong Project'],
    color: '#00eeff',
  },
  {
    id: 'git',
    label: 'Git / GitHub',
    category: 'Core',
    level: 'expert',
    experience: '7+ years',
    projects: [''],
    color: '#ff00ee',
  },
  {
    id: 'api',
    label: 'REST API',
    category: 'Core',
    level: 'expert',
    experience: '7+ years',
    projects: [''],
    color: '#ff00ee',
  },
  {
    id: 'linux',
    label: 'Linux',
    category: 'Core',
    level: 'expert',
    experience: '7+ years',
    projects: [''],
    color: '#00eeff',
  },
  {
    id: 'postman',
    label: 'Postman',
    category: 'Core',
    level: 'expert',
    experience: '8+ years',
    projects: [''],
    color: '#00eeff',
  },
  {
    id: 'docker',
    label: 'Docker',
    category: 'Core',
    level: 'beginner',
    experience: '6 months',
    projects: [''],
    color: '#ff00ee',
  },
  {
    id: 'cpanel',
    label: 'cPanel',
    category: 'Core',
    level: 'expert',
    experience: '7+ years',
    projects: [''],
    color: '#00eeff',
  },
  {
    id: 'd365',
    label: 'Dynamics 365',
    category: 'Core',
    level: 'average',
    experience: '2 years',
    projects: [''],
    color: '#ff00ee',
  },
  // {
  //   id: 'pa',
  //   label: 'Power Automate',
  //   category: 'Backend',
  //   level: 'expert',
  //   experience: '7+ years',
  //   projects: [''],
  //   color: '#68a063',
  // },
  // {
  //   id: 'pbi',
  //   label: 'Power BI',
  //   category: 'Backend',
  //   level: 'expert',
  //   experience: '7+ years',
  //   projects: [''],
  //   color: '#68a063',
  // },
]